var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarketmuseBrief = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 77,
    viewBox: "0 0 67 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H43.0586V54.378H0V0Z",
    transform: "matrix(0.907874 0.419242 -0.418068 0.908416 23.8672 1)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0586 5.10656V0H0V54.378H6.05296V59.4845H49.1115V5.10656H43.0586Z",
    transform: "matrix(0.907874 0.419242 -0.418068 0.908416 23.8672 1)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.62389e-07 0H31.5029",
    transform: "matrix(0.907874 0.419242 -0.418068 0.908416 24.7852 12.8262)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31194e-07 -3.8147e-07H31.5029",
    transform: "matrix(0.907874 0.419242 -0.418068 0.908416 22.207 19.084)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31194e-07 -7.62939e-07H31.5029",
    transform: "matrix(0.907874 0.419242 -0.418068 0.908416 19.3789 25.2266)",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31194e-07 3.8147e-07H15.8202",
    transform: "matrix(0.907874 0.419242 -0.418068 0.908416 16.6094 31.2461)",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketmuseBrief);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marketmuse-brief.71f31f107ffb42765256d84da480f649.svg";